import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const TasksModule = lazy(loadModule);

export default TasksModule;
